import { useState, useEffect } from "react";
import { SignIn } from "@clerk/clerk-react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";

/**
 * Sign In Page with Clerk Authentication
 * Uses Clerk's pre-built SignIn component with Material-UI styling
 * Includes "Remember Me" checkbox for extended session duration
 */
export default function SignInPage() {
  const [rememberMe, setRememberMe] = useState(() => {
    // Load saved preference from localStorage
    return localStorage.getItem("clerk_remember_me") === "true";
  });

  // Save preference to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("clerk_remember_me", rememberMe.toString());

    // Trigger a custom event so ClerkProvider can react to changes
    window.dispatchEvent(new CustomEvent("rememberMeChanged", { detail: { rememberMe } }));
  }, [rememberMe]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: (theme) => theme.palette.background.default,
        gap: 2,
      }}
    >
      <SignIn
        routing="path"
        path="/signin"
        signUpUrl="/clerk-signup"
        redirectUrl="/tables"
      />

      <Box
        sx={{
          width: 400,
          px: 2,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              color="primary"
            />
          }
          label={
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Remember me
            </Typography>
          }
        />
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ ml: 4, mt: -0.5 }}
        >
          {rememberMe
            ? "Stay signed in for 7 days"
            : "Session expires after 1 hour of inactivity"}
        </Typography>
      </Box>
    </Box>
  );
}
